/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '@/services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [response: vp.FetchAccountUsersResponse, fetchData: () => void, reset: () => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchUsers: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [response, setResponse] = useState<vp.FetchAccountUsersResponse>({
    Success: false,
    ErrorMessage: '',
    Users: [],
  });
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const source = axios.CancelToken.source();
  useEffect(() => {
    if (!shouldFetchData) return () => {};

    const loadData = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const res = await api.fetchPartnerAccountUsers(source);
      setResponse(res);
      setDataFetchingInfo(false);
    };
    if (shouldFetchData) void loadData();
    setShouldFetchData(false);
    return () => {
      source.cancel();
    };
  }, [shouldFetchData]);

  return [
    response,
    () => {
      setShouldFetchData(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        Users: [],
      });
      setShouldFetchData(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchUsers);
